import * as Yup from 'yup';

export const validationSchema = () =>
  Yup.object({
    notifyTypeId: Yup.string().required('Required').nullable(),
    timeZoneId: Yup.string().required('Required').nullable(),
  });
